export const SHIPPING_MODEL = {
  Delivery: '1',
  TakeOut: '2',
};
